import { render, staticRenderFns } from "./SupplementaryReview.vue?vue&type=template&id=18331843&scoped=true"
import script from "./SupplementaryReview.vue?vue&type=script&lang=js"
export * from "./SupplementaryReview.vue?vue&type=script&lang=js"
import style0 from "./SupplementaryReview.vue?vue&type=style&index=0&id=18331843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18331843",
  null
  
)

export default component.exports